/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseVignetteDetailView } from '../../models/response-vignette-detail-view';

export interface GetVignetteDetail$Params {

/**
 * the id of the vignette
 */
  id: string;

/**
 * customer GUID from svgzapi-core
 */
  customerGUID: string;
}

export function getVignetteDetail(http: HttpClient, rootUrl: string, params: GetVignetteDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseVignetteDetailView>> {
  const rb = new RequestBuilder(rootUrl, getVignetteDetail.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('customerGUID', params.customerGUID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseVignetteDetailView>;
    })
  );
}

getVignetteDetail.PATH = '/vignette/{id}';
